export const detailsStateClosedClass = 'details-state-closed';
export const detailsStateOpenClass = 'details-state-open';
